import { RegularButton } from 'fronton-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { jc } from 'utils';
import { PDP_REVIEWS_ADD_NEW_CLICK } from '../../actions';
import { getIsClientVerificationPending } from 'features/client-verification/ducks/selectors';
import { VERIFY_CLIENT } from 'features/client-verification/ducks/client-verification';

type PdpReviewsAddNewProps = { wide?: boolean } & React.HTMLAttributes<HTMLElement>;

export const PdpReviewsAddNew: React.FC<PdpReviewsAddNewProps> = ({
  wide,
  className = '',
  onClick,
  ...htmlProps
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isPending = useSelector(getIsClientVerificationPending);

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    if (isPending) return;

    dispatch(PDP_REVIEWS_ADD_NEW_CLICK());
    dispatch(VERIFY_CLIENT());
    onClick?.(event);
  };

  return (
    <div className={jc(className)} {...htmlProps}>
      <RegularButton loading={isPending} onClick={handleClick} size="l" variant="primary" wide={wide}>
        {t('reviews.form.ui.write-review')}
      </RegularButton>
    </div>
  );
};
